import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Constant } from '../constant';

var jsonResponse: any;
@Injectable({
  providedIn: 'root'
})
export class ImportantPersonService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient, private constant: Constant) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    headers = headers.set('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
    this.httpOptions.headers = headers;
  }

  getImportantPerson(): Observable<any> {
    return this.http.get<any>(this.constant.API_ENDPOINT + '/important-person', this.httpOptions);
  }

  getImportantPersonById(id): Observable<any> {
    return this.http.get<any>(this.constant.API_ENDPOINT + '/important-person/' + id, this.httpOptions);
  }

  updateImportantPerson(id, department): Observable<any> {
    return this.http.put<any>(this.constant.API_ENDPOINT + '/important-person/' + id, JSON.stringify(department),
    this.httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  addImportantPerson(department): Observable<any> {
    return this.http.post<any>(this.constant.API_ENDPOINT + '/important-person', JSON.stringify(department),
    this.httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  deleteImportantPerson(id): Observable<any> {
    return this.http.patch<any>(this.constant.API_ENDPOINT + '/important-person/' + id, {},
    this.httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  // Error handling
  handleError(error) {
  console.log(error);
  let errorMessage = '';
  if(error.error && error.error.data) {
    errorMessage = error.error.data.error_message;
  }
  return throwError(errorMessage);
  }
}